import { CanActivateChildFn } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { map, tap } from 'rxjs/operators';
import { MembershipActions } from '@aaa/emember/store-membership';
import { WindowRefService } from '../../share/services/window-ref.service';
import { LocationRefService } from '../../share/services/location-ref.service';

export const loadMembership: CanActivateChildFn = () => {
  const windowRef = inject(WindowRefService);
  const store = inject(Store);
  const location = inject(LocationRefService);
  const metaaDataMembershipNumber = windowRef.nativeWindow?.metaData?.user?.memberNumber;

  return location.getSearchParam('memNo').pipe(
    tap((memNo) => {
      const membershipNumber = memNo || metaaDataMembershipNumber || '';

      store.dispatch(MembershipActions.load({ membershipNumber, enableCache: false }));
    }),
    map(() => true),
  );
};

export default loadMembership;
